


// import React from "react";
// import { Link } from "react-router-dom";

// const Footer = () => {
//   return (
//     <footer className="bg-black text-white py-12 px-4">
//       <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
//         {/* Column 1 */}
//         <div className="text-center">
//           <img src="/images/footer/logo.png" alt="Abone Halı Yıkama" className="mb-4 h-10 mx-auto" />
//           <ul className="space-y-6">
//             <li><Link to="/hali-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">HALI YIKAMA</Link></li>
//             <li><Link to="/koltuk-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">KOLTUK YIKAMA</Link></li>
//             <li><Link to="/yatak-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">YATAK YIKAMA</Link></li>
//             <li><Link to="/yorgan-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">YORGAN YIKAMA</Link></li>
//             <li><Link to="/stor-zebra-perde-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">PERDE YIKAMA</Link></li>
//             <li><Link to="/yerinde-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">YERİNDE YIKAMA</Link></li>
//             <li><Link to="/hali-tamir-overlok" className="flex items-center gap-2 justify-center underline underline-offset-8">HALI TAMİR - OVERLOK</Link></li>
//             <li><Link to="/kuru-temizleme" className="flex items-center gap-2 justify-center underline underline-offset-8">KURU TEMİZLEME</Link></li>
//           </ul>
//         </div>

//         {/* Column 2 */}
//         <div className="text-center">
//           <img src="/images/footer/logo.png" alt="Abone Halı Yıkama" className="mb-4 h-10 mx-auto" />
//           <ul className="space-y-6">
//             <li><Link to="/" className="block underline underline-offset-8">ANA MENÜ</Link></li>
//             <li><Link to="/kurumsal" className="block underline underline-offset-8">KURUMSAL MENÜ</Link></li>
//             <li><Link to="/bolgeler" className="block underline underline-offset-8">HİZMET BÖLGELERİ</Link></li>
//             <li><Link to="/galeri/tum-galeri" className="block underline underline-offset-8">GALERİ</Link></li>
//             <li><Link to="/blog" className="block underline underline-offset-8">BLOG</Link></li>
//             {/* <li><Link to="/iletisim" className="block underline underline-offset-8">İLETİŞİM</Link></li> */}
//           </ul>
//         </div>

//         {/* Column 3 */}
//         <div className="text-center space-y-6">
//           <img src="/images/footer/callcenter.png" alt="Destek" className="h-20 mx-auto" />
//           <div>
//             <h4 className="font-semibold underline underline-offset-8">ÇAĞRI MERKEZİ</h4>
//             <p>0 (501) 533 60 66</p>
//           </div>
//           <div className="flex justify-center gap-4 mt-2">
//             <a href="https://wa.me/905015335060" target="_blank" rel="noopener noreferrer">
//               <img src="/images/footer/whatsapp.png" className="w-6" alt="WhatsApp" />
//             </a>
//             <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
//               <img src="/images/footer/facebook.png" className="w-6" alt="Facebook" />
//             </a>
//             <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
//               <img src="/images/footer/instagram.png" className="w-6" alt="Instagram" />
//             </a>
//           </div>
//           <div className="flex justify-center mt-4">
//             <img src="/images/footer/magaza.png" alt="Mağaza" className="w-48 rounded" />
//           </div>
//         </div>
//       </div>

//       <div className="text-center text-sm text-gray-400 mt-8">
//         <p>© 2015 Abone Halı Yıkama. Tüm hakları saklıdır.</p>
//         <p className="mt-1">
//           Web tasarım:{" "}
//           <a href="https://boldsoftware.com.tr" target="_blank" rel="noopener noreferrer" className="underline underline-offset-8">
//             BoldSoft
//           </a>
//         </p>
//         <div className="mt-2">
//           <img src="/images/footer/boldsoftlogo.png" alt="BoldSoft" className="h-6 mx-auto" />
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12 px-4">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
        {/* Column 1 */}
        <div className="text-center">
          <img
            src="/images/footer/logo.png"
            alt="Abone Halı Yıkama"
            width={3560}
            height={721}
            className="w-48 mx-auto mb-6"
          />
          <ul className="space-y-4 text-sm">
            <li><Link to="/hali-yikama" className="underline underline-offset-4">HALI YIKAMA</Link></li>
            <li><Link to="/koltuk-yikama" className="underline underline-offset-4">KOLTUK YIKAMA</Link></li>
            <li><Link to="/yatak-yikama" className="underline underline-offset-4">YATAK YIKAMA</Link></li>
            <li><Link to="/yorgan-yikama" className="underline underline-offset-4">YORGAN YIKAMA</Link></li>
            <li><Link to="/stor-zebra-perde-yikama" className="underline underline-offset-4">PERDE YIKAMA</Link></li>
            <li><Link to="/yerinde-yikama" className="underline underline-offset-4">YERİNDE YIKAMA</Link></li>
            <li><Link to="/hali-tamir-overlok" className="underline underline-offset-4">HALI TAMİR - OVERLOK</Link></li>
            <li><Link to="/kuru-temizleme" className="underline underline-offset-4">KURU TEMİZLEME</Link></li>
          </ul>
        </div>

        {/* Column 2 */}
        <div className="text-center">
          <img
            src="/images/footer/logo.png"
            alt="Abone Halı Yıkama"
            width={3560}
            height={721}
            className="w-48 mx-auto mb-6"
          />
          <ul className="space-y-4 text-sm">
            <li><Link to="/" className="underline underline-offset-4">ANA MENÜ</Link></li>
            <li><Link to="/kurumsal" className="underline underline-offset-4">KURUMSAL MENÜ</Link></li>
            <li><Link to="/bolgeler" className="underline underline-offset-4">HİZMET BÖLGELERİ</Link></li>
            <li><Link to="/galeri/tum-galeri" className="underline underline-offset-4">GALERİ</Link></li>
            <li><Link to="/blog" className="underline underline-offset-4">BLOG</Link></li>
          </ul>
        </div>

        {/* Column 3 */}
        <div className="text-center space-y-4">
          <img
            src="/images/footer/callcenter.png"
            alt="Çağrı Merkezi"
            width={1259}
            height={1080}
            className="w-32 h-auto mx-auto rounded-full object-cover"
          />
          <div>
            <h4 className="font-semibold underline underline-offset-4">ÇAĞRI MERKEZİ</h4>
            <p className="text-lg text-[#caffcc] font-medium">0 (501) 533 60 66</p>
          </div>
          <div className="flex justify-center gap-4 mt-2">
            <a href="https://wa.me/905015335060" target="_blank" rel="noopener noreferrer">
              <img
                src="/images/footer/whatsapp.png"
                alt="WhatsApp"
                width={600}
                height={600}
                className="w-8"
              />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <img
                src="/images/footer/facebook.png"
                alt="Facebook"
                width={600}
                height={600}
                className="w-8"
              />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <img
                src="/images/footer/instagram.png"
                alt="Instagram"
                width={600}
                height={600}
                className="w-8"
              />
            </a>
          </div>
          <div className="flex justify-center mt-4">
            <img
              src="/images/footer/magaza.png"
              alt="Mağaza"
              width={600}
              height={600}
              className="w-48 rounded shadow-lg"
            />
          </div>
        </div>
      </div>

      {/* Alt kısım */}
      <div className="text-center text-sm text-gray-400 mt-10">
        <p>© 2015 Abone Halı Yıkama. Tüm hakları saklıdır.</p>
        <p className="mt-1">
          Web tasarım:{" "}
          <a
            href="https://boldsoftware.com.tr"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4"
          >
            BoldSoft
          </a>
        </p>
        <div className="mt-3">
          <img
            src="/images/footer/boldsoftlogo.png"
            alt="BoldSoft"
            width={3834}
            height={777}
            className="w-28 mx-auto"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
